import { Typography, TypographyProps } from '@mui/material';
import { useCurrencySymbol } from '../../hooks/useCurrencySymbol';

type CurrencySymbolProps = TypographyProps & {
  currency?: string;
  variant?: string;
};

export const CurrencySymbol = ({ currency, variant, ...typographyProps }: CurrencySymbolProps) => {
  const symbol = useCurrencySymbol(currency);

  return (
    <Typography component='span' variant={variant || 'inherit'} {...typographyProps}>
      {symbol}
    </Typography>
  );
};
